import { OrderListColumnKey } from './column-registry';

export type OrderListIncludeVariables = {
    includeStatus: boolean;
    includeOrderId: boolean;
    includeOrderIdOnly: boolean;
    includeInternalOrderId: boolean;
    includePatient: boolean;
    includeConstructions: boolean;
    includeCustomer: boolean;
    includePrice: boolean;
    includeCreated: boolean;
    includeDeliveryDeadline: boolean;
    includeTimeInStep: boolean;
    includeWorkflow: boolean;
    includeWorkStatus: boolean;
    includeMaterials: boolean;
    includeDelivery: boolean;
    includeInternalDeliveryDate: boolean;
    includeExternalDeliveryDate: boolean;
};

const ALL_INCLUDE_FALSE: OrderListIncludeVariables = {
    includeStatus: false,
    includeOrderId: false,
    includeOrderIdOnly: false,
    includeInternalOrderId: false,
    includePatient: false,
    includeConstructions: false,
    includeCustomer: false,
    includePrice: false,
    includeCreated: false,
    includeDeliveryDeadline: false,
    includeTimeInStep: false,
    includeWorkflow: false,
    includeWorkStatus: false,
    includeMaterials: false,
    includeDelivery: false,
    includeInternalDeliveryDate: false,
    includeExternalDeliveryDate: false,
};

const COLUMN_KEY_TO_INCLUDE_VARIABLE: Partial<Record<OrderListColumnKey, keyof OrderListIncludeVariables>> = {
    status: 'includeStatus',
    orderId: 'includeOrderId',
    orderIdOnly: 'includeOrderIdOnly',
    internalOrderId: 'includeInternalOrderId',
    patient: 'includePatient',
    constructions: 'includeConstructions',
    customer: 'includeCustomer',
    price: 'includePrice',
    created: 'includeCreated',
    deliveryDeadline: 'includeDeliveryDeadline',
    timeInStep: 'includeTimeInStep',
    workflow: 'includeWorkflow',
    workStatus: 'includeWorkStatus',
    materials: 'includeMaterials',
    delivery: 'includeDelivery',
    internalDeliveryDate: 'includeInternalDeliveryDate',
    externalDeliveryDate: 'includeExternalDeliveryDate',
};

export const buildIncludeVariables = (activeColumnKeys: OrderListColumnKey[]): OrderListIncludeVariables => {
    const result: OrderListIncludeVariables = { ...ALL_INCLUDE_FALSE };
    for (const key of activeColumnKeys) {
        const variable = COLUMN_KEY_TO_INCLUDE_VARIABLE[key];
        if (variable) result[variable] = true;
    }
    return result;
};
